// extracted by mini-css-extract-plugin
module.exports = {"widthControl":"WorkspacePageLayout_widthControl__DP9CT","topMenu":"WorkspacePageLayout_topMenu__FL5Ih"};